import type { FC, ReactElement } from 'react';

import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { Icon } from '../../icons/icon';
import { Icons } from '../../icons/iconNames';
import styles from '../Popup.module.css';

export const ReconnectingPopup: FC = (): ReactElement => (
  <div className={styles.popup__reconnecting}>
    <Icon icon={Icons.Update} className={styles.popup__reconnecting__icon} />
    <L10nText tk="CONNECT_SERVER" />
  </div>
);
